/** In browser and worker environments, we use the default options. */
export const fetchOptions: Partial<RequestInit> = {};
/**
 * Use the native `fetch` function in the browser and worker environments.
 */
export const fetch = globalThis.fetch;
const _Headers = Headers;
export { _Headers as Headers };

export type RequestInit = globalThis.RequestInit;
export type Response = globalThis.Response;
export type Blob = globalThis.Blob;
